<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col md="10" lg="8" xl="6" sm="12">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-chart-pie</v-icon>
            Tool Up-Time History
            <v-spacer />
            <v-select
              :items="ranges"
              v-model="range"
            />
            <v-btn @click="refresh">Submit</v-btn>
          </v-card-title>
          <v-data-table
            :loading="loading"
            :items="items"
            :headers="headers"
            :search="search"
          >
            <template #item.state.name="{ item }">
              <v-icon left small :color="item.state.color">{{ item.state.icon }}</v-icon>{{ item.state.name }}
            </template>
            <template #item.span="{ item }">
              {{ item.dynamicSpan }}
            </template>
          </v-data-table>
          <v-card-text>
            <canvas id="myChart" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Chart from 'chart.js';
import ToolStateHistory from "../../models/ToolStateHistory";
export default {
  name: "ToolStateHistoryView",
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      search: "",
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      range: "month",
      ranges: [
        "month",
        "week",
        "year"
      ],
      headers: [
        {
          text: "Timestamp",
          align: "left",
          sortable: true,
          value: "created"
        },
        {
          text: "State",
          value: "state.name"
        },
        {
          text: "Duration (days)",
          value: "span"
        }
      ]
    }
  },
  computed: {
    items() {
      return ToolStateHistory.query()
        .where("tool_id", parseInt(this.id))
        .with("state")
        .orderBy("created", "desc")
        .get();
    },
    stateRepair() {
      return {span: ToolStateHistory.historyByState(1, parseInt(this.id)), state: "Repair"}
    },
    stateRunning() {
      return {span: ToolStateHistory.historyByState(2, parseInt(this.id)), state: "Running"}
    },
    stateEngineering() {
      return {span: ToolStateHistory.historyByState(3, parseInt(this.id)), state: "Engineering"}
    },
    stateIdle() {
      return {span: ToolStateHistory.historyByState(4, parseInt(this.id)), state: "Idle"}
    },
    statePreventative() {
      return {span: ToolStateHistory.historyByState(5, parseInt(this.id)), state: "Maintenance"}
    },
    chartData() {
      return {
        type: "pie",
        data: {
          labels: ["Repair", "Running", "Engineering", "Idle", "Preventative"],
          datasets: [
            {
              data: [this.stateRepair.span, this.stateRunning.span, this.stateEngineering.span, this.stateIdle.span, this.statePreventative.span],
              backgroundColor: [
                "#D32F2F",
                "#388E3C",
                "#FBC02D",
                "#1976D2",
                "#C2185B"
              ]
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.loading = true;
      ToolStateHistory.$fetchByTool(this.id, this.range)
        .then(() => {
          this.loading = false;
          this.createChart('myChart', this.chartData);
        });
    },
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    }
  }
}
</script>
